import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c3fffe2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "productDescriptionEntry" };
const _hoisted_2 = { class: "productDescriptionEntry-Header px-0 py-4" };
const _hoisted_3 = { class: "font6-responsive text-left" };
const _hoisted_4 = {
    key: 0,
    class: "productDescriptionEntry-Content font6-responsive pl-3 pr-3 pb-4 text-left"
};
const _hoisted_5 = {
    class: "ProductDetailsContentWrapper mb-5 d-flex",
    style: { "flex-direction": "column" }
};
const _hoisted_6 = {
    key: 0,
    class: "attributeMobil py-1 zustandsAttribute border-bottom",
    style: { "order": "1" }
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", { class: "float-left" }, "Optischer Zustand", -1));
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
    key: 1,
    class: "attributeMobil py-1 border-bottom",
    style: { "order": "2" }
};
const _hoisted_10 = { class: "float-left [ JS_attributeMobile_NameUpdate ]" };
const _hoisted_11 = { class: "float-right pl-2 [ JS_attributeMobile_valueUpdate ]" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, [
                _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleExpansion())),
                    title: "Productdetails",
                    class: "pl-0 pr-1 d-flex justify-content-between align-items-start strong pointerhover fc-brand_deep_blue",
                    role: "button"
                }, [
                    _createTextVNode(" Produktdetails "),
                    _createElementVNode("i", {
                        class: _normalizeClass([{ 'icon-brand_plus': !_ctx.expanded, 'icon-brand_minus': _ctx.expanded }, "float-right ml-4 fc-brand_green_hover"])
                    }, null, 2)
                ])
            ])
        ]),
        _createVNode(_Transition, {
            name: "collapse",
            duration: 280
        }, {
            default: _withCtx(() => [
                (_ctx.expanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProduct.attributes, (entry, key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                    (key.toString() === 'condition')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _hoisted_7,
                                            _createTextVNode(" : "),
                                            _createElementVNode("span", {
                                                class: "float-right pl-2 [ JS_attributeMobile_valueCondition ]",
                                                innerHTML: _ctx.currentProduct.condition
                                            }, null, 8, _hoisted_8)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("strong", _hoisted_10, _toDisplayString(entry.attribute_name), 1),
                                            _createTextVNode(" : "),
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(entry.attribute_value), 1)
                                        ]))
                                ], 64));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
